import { WarningImage } from '@approvalmax/ui';
import { Box, Flex, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { messages } from './NoTransactions.messages';

export const NoTransactions = memo(() => {
    return (
        <Flex alignItems='center' justifyContent='center'>
            <Box color='white100' radius='small' spacing='40 32' width={416}>
                <Flex alignItems='center' direction='column' justifyContent='center' spacing='24'>
                    <WarningImage width={100} height={100} />

                    <Text color='midnight80' font='headline' fontSize='small' fontWeight='medium' textAlign='center'>
                        {messages.title}
                    </Text>
                </Flex>
            </Box>
        </Flex>
    );
});

NoTransactions.displayName = 'NoTransactions';
